import { registerHandler } from 'event-bus';
import updateMarket from './update_market';

export default ({ eId, mtId }) => eId
  && mtId
  && registerHandler(`/event/${eId}/marketsummary/${mtId}`, updateMarket);
